import React from 'react'
import styles from './styles.css'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import {Form, Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Button from 'orionsoft-parts/lib/components/Button'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import {withRouter} from 'react-router'

@withRouter
@withMutation(gql`
  mutation createOrganization($name: String) {
    createOrganization(name: $name) {
      _id
      name
      createdAt
    }
  }
`)
@withMessage
export default class Main extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    createOrganization: PropTypes.object
  }

  state = {}

  async create() {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.createOrganization(
        {name: this.state.Nombre},
        {
          refetchQueries: ['organizationUser']
        }
      )
      this.props.router.push(`/`)
      this.props.showMessage('Organización creada')
    } catch (error) {
      console.log('Error:', error)
    }
    this.setState({loading: false})
  }

  renderCreate() {
    return (
      <div className="section">
        <div className="header">
          <h3>Crear una Organización</h3>
        </div>
        <div className="content">
          <Form state={this.state} onChange={changes => this.setState(changes)}>
            <Field fieldName="Nombre" placeholder="Nombre" type={Text} />
          </Form>
          <br />
          <Button
            primary
            disabled={!this.state || !this.state.Nombre}
            loading={this.state.loading}
            onClick={() => this.create()}
          >
            Crear organización
          </Button>
        </div>
      </div>
    )
  }

  render() {
    return <div className={styles.container}>{this.renderCreate()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Createorganization/Main/index.js